<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M14.545 12l8.807-8.807A1.8 1.8 0 1020.807.648L12 9.455 3.193.647A1.8 1.8 0 10.648 3.192L9.455 12 .647 20.807a1.8 1.8 0 102.546 2.546L12 14.545l8.807 8.807a1.797 1.797 0 002.546.001 1.8 1.8 0 000-2.545L14.545 12z"
    />
  </svg>
</template>
